import React from "react";
import Link from "gatsby-link";
import footerLogo from "./../../images/mb/logo_footer.png";
import rocketSymbol from "./../../images/mb/rocket_link.png";

import SocialIcons from "../SocialIcons";

const Footer = ({ pages }) => (
  <footer>
    <div className=" bg-white footer-top">
      <div className="container">
        <div className="row margin-four">
          <div className="col-sm-6 text-center">
            <div title="Code: 0xe800" className="the-icons span3">
              <i className="icon-location" />
            </div>
            <h6 className="black-text margin-two no-margin-bottom">Toronto, Canada</h6>
          </div>
          <div className="col-sm-6 text-center">
            <div title="Code: 0xe801" className="the-icons span3">
              <i className="icon-mail" />
            </div>
            <h6 className="margin-two no-margin-bottom">
              <a href="mailto:info@moonbeyond.com" className="black-text">
                info@moonbeyond.com
              </a>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div className="container footerMiddle">
      <div className="row footerMiddle_firstRow">
        <div className="col-md-4">
          <img className="footerLogo" src={footerLogo} alt="" />
        </div>
        <div className="col-md-8 footerDescription">
          <p className="footerText">
            <span>MOON BEYOND CREATIVE </span>
            We are a visual design agency dedicated to taking you further
            <img className="counter-img" src={rocketSymbol} />
          </p>
        </div>
      </div>
    </div>
    <div className="container-fluid footerBottom">
      <div className="row">
        <div className="col-md-4 blackFooterSegment" />
        <div className="col-md-1 no-padding greyFooterDiagonalShape_container">
          <div className="greyFooterDiagonalShape" />
        </div>
        <div className="col-md-7 hidden-sm greyFooterSegment" />
      </div>
      <div className="container footerAllLinks">
        <div className="row">
          <div className="col-md-7 col-md-offset-1 footerMainLinks_container">
            <ul id="menu-footer-menu" className="footerMainLinks">
              {pages.map((a, i) => (
                <li key={i} className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item">
                  <Link to={`/${a.object_slug !== "home" ? a.object_slug : ""}`}>{a.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-md-4 footer-social text-left sm-text-center socialMediaLinks">
            <SocialIcons light />
          </div>
        </div>
        <div className="row margin-three">
          <div className="col-md-6 col-sm-12 copyright text-left letter-spacing-1 sm-text-center xs-margin-bottom-one">
            &copy; {new Date().getFullYear()} Moon Beyond.
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js